/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_ActivitiesInputs */

const en_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activities`)
};

const de_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitäten`)
};

const es_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividades`)
};

const fr_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activités`)
};

const it_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività`)
};

const pt_br2_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividades`)
};

const pl_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywności`)
};

const hu_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tevékenységek`)
};

const ro_admin_dashboard_activities = /** @type {(inputs: Admin_Dashboard_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activitati`)
};

/**
* | output |
* | --- |
* | "Activities" |
*
* @param {Admin_Dashboard_ActivitiesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_activities = /** @type {((inputs?: Admin_Dashboard_ActivitiesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_ActivitiesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_activities(inputs)
	if (locale === "de") return de_admin_dashboard_activities(inputs)
	if (locale === "es") return es_admin_dashboard_activities(inputs)
	if (locale === "fr") return fr_admin_dashboard_activities(inputs)
	if (locale === "it") return it_admin_dashboard_activities(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_activities(inputs)
	if (locale === "pl") return pl_admin_dashboard_activities(inputs)
	if (locale === "hu") return hu_admin_dashboard_activities(inputs)
	return ro_admin_dashboard_activities(inputs)
});
export { admin_dashboard_activities as "admin.dashboard.activities" }